import { useState } from 'react';

interface IBroadcastCompleteModalState {
  totalRecipients: number;
  deliveredCount: number;
  queuedCount: number;
}

export const useBroadcastCompleteModal = () => {
  const [showBroadcastCompleteModal, setShowBroadcastCompleteModal] = useState(false);
  const [broadcastResponse, setBroadcastResponse] = useState<IBroadcastCompleteModalState | null>(null);

  const openBroadcastCompleteModal = (response: IBroadcastCompleteModalState) => {
    setBroadcastResponse(response);
    setShowBroadcastCompleteModal(true);
  };

  const closeBroadcastCompleteModal = () => {
    setShowBroadcastCompleteModal(false);
    setBroadcastResponse(null);
  };

  return {
    showBroadcastCompleteModal,
    broadcastResponse,
    openBroadcastCompleteModal,
    closeBroadcastCompleteModal,
    setBroadcastResponse 
  };
};
